<!--
  =========================================================
  * Vue Material Dashboard 2 - v3.1.0
  =========================================================
  
  * Product Page: https://creative-tim.com/product/vue-material-dashboard-2
  * Copyright 2023 Creative Tim (https://www.creative-tim.com)
  
  Coded by www.creative-tim.com
  
   =========================================================
  
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  -->

<template>
  <div class="app-wrapper">
    <!-- Side navigation - Only show if authenticated -->
    <sidenav
      :custom_class="color"
      :class="[isRTL ? 'fixed-end' : 'fixed-start']"
      v-if="showSidenav && isAuthenticated"
    />

    <div class="main-wrapper">
      <main class="main-content position-relative">
        <!-- Navigation bar - Only show if authenticated -->
        <navbar
          :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
          :color="isAbsolute ? 'text-white opacity-8' : ''"
          :minNav="navbarMinimize"
          v-if="showNavbar && isAuthenticated"
        />

        <!-- <div class="content-wrapper"> -->
        <router-view />
        <!-- </div> -->

        <!-- Footer - Only show if authenticated -->
        <app-footer v-show="showFooter && isAuthenticated" />

        <!-- Configurator (commented out) -->
        <!-- <configurator
          :toggle="toggleConfigurator"
          :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']"
        /> -->
      </main>
    </div>
  </div>
</template>

<script>
import Sidenav from "./examples/Sidenav";
import AppFooter from "@/examples/Footer.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import authService from "@/services/auth";

// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//   failedQueue.forEach((prom) => {
//     if (error) {
//       prom.reject(error);
//     } else {
//       prom.resolve(token);
//     }
//   });

//   isRefreshing = false;
//   failedQueue = [];
// };

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
    AppFooter,
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "showNavbar",
      "absolute",
      "showSidenav",
      "showFooter",
      "showConfig",
      "hideConfigButton",
    ]),
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"];
    },
  },
  created() {
    axios.defaults.baseURL = "https://tmiddlewareadmin.lgrb.go.ug/vue-api/";
    // axios.defaults.baseURL = "http://127.0.0.1:8000/vue-api/";
    // axios.defaults.baseURL = "http://10.255.6.67:8002/vue-api/";
    axios.defaults.headers.common["Content-Type"] = "application/json";

    // Add authentication token to all requests
    axios.interceptors.request.use(
      (config) => {
        // Skip authentication for sign-up, sign-in, and refresh endpoints
        const publicEndpoints = [
          "/operators/",
          "/sign-in/",
          "/token/",
          "/token/refresh/",
        ];

        if (publicEndpoints.some((endpoint) => config.url.includes(endpoint))) {
          return config;
        }

        const token = authService.getAccessToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    // Handle 401 responses with token refresh
    // axios.interceptors.response.use(
    //   (response) => response,
    //   (error) => {
    //     const originalRequest = error.config;

    //     // Handle 401 errors
    //     if (
    //       error.response &&
    //       error.response.status === 401 &&
    //       !originalRequest._retry
    //     ) {
    //       // Prevent infinite loops
    //       if (originalRequest.url.includes("/token/refresh/")) {
    //         this.$store.dispatch("auth/logout");
    //         this.$router.push("/sign-in");
    //         return Promise.reject(error);
    //       }

    //       if (isRefreshing) {
    //         return new Promise((resolve, reject) => {
    //           failedQueue.push({ resolve, reject });
    //         })
    //           .then((token) => {
    //             originalRequest.headers.Authorization = `Bearer ${token}`;
    //             return axios(originalRequest);
    //           })
    //           .catch((err) => {
    //             return Promise.reject(err);
    //           });
    //       }

    //       originalRequest._retry = true;
    //       isRefreshing = true;

    //       return this.$store
    //         .dispatch("auth/refreshToken")
    //         .then((success) => {
    //           if (success) {
    //             const token = authService.getAccessToken();
    //             originalRequest.headers.Authorization = `Bearer ${token}`;
    //             processQueue(null, token);
    //             return axios(originalRequest);
    //           } else {
    //             this.$router.push("/sign-in");
    //             return Promise.reject(error);
    //           }
    //         })
    //         .catch((err) => {
    //           processQueue(err, null);
    //           this.$router.push("/sign-in");
    //           return Promise.reject(err);
    //         });
    //     }

    //     // Handle other errors
    //     if (error.response && error.response.status === 401) {
    //       this.$store.dispatch("auth/logout");
    //       this.$router.push("/sign-in");
    //     }

    //     return Promise.reject(error);
    //   },
    // );
  },
  beforeMount() {
    // Initialize store state
    this.$store.state.isTransparent = "bg-transparent";

    // Initialize sidenav pinned state based on window width
    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav?.classList.add("g-sidenav-pinned");
    }
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.app-wrapper {
  display: flex;
  min-height: 100vh;
  width: 100%;
}

.main-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}
.main-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
}

.content-wrapper {
  flex: 1 0 auto;
  width: 100%;
}

.app-footer {
  flex-shrink: 0;
}

.fixed-start {
  left: 0;
}

.fixed-end {
  right: 0;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.max-height-vh-100 {
  max-height: 100vh;
}

.g-sidenav-show .main-wrapper {
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

@media (max-width: 1200px) {
  .g-sidenav-show .main-wrapper {
    margin-left: 0;
  }

  .g-sidenav-pinned {
    transform: translateX(0);
  }
}

@media print {
  .app-footer {
    display: none;
  }

  .main-wrapper {
    min-height: auto;
  }
}
</style>
